import { memo } from 'react';
import { Card, Form, Space, Checkbox, Input } from 'antd';

export const FormMetadataSettings = memo(function FormMetadataSettings({
	metadata,
	onChange,
	formType,
	isSuperAdmin = true,
}) {
	const currentMetadata = metadata || {
		askForResume: false,
		resumeRequired: false,
		showUserEmail: false,
	};
	const updateMetadata = (key, value) => {
		const updatedMetadata = { ...currentMetadata, [key]: value };
		onChange(updatedMetadata);
	};

	return (
		<Card
			title={
				<div style={{ fontWeight: 900, fontSize: '16px' }}>
					Form Settings
				</div>
			}
			size="small"
			style={{ marginBottom: '16px', borderRadius: '8px' }}
		>
			<Form layout="vertical">
				{formType.toLowerCase() !== 'custom' && (
					<>
						<Form.Item>
							<Space direction="vertical" style={{ width: '100%' }}>
								<Checkbox
									checked={currentMetadata.askForResume}
									onChange={(e) =>
										updateMetadata('askForResume', e.target.checked)
									}
								>
									Ask for resume attachment
								</Checkbox>

								{currentMetadata.askForResume && (
									<Checkbox
										checked={currentMetadata.resumeRequired}
										onChange={(e) =>
											updateMetadata(
												'resumeRequired',
												e.target.checked,
											)
										}
										style={{ marginLeft: '24px' }}
									>
										Resume is required
									</Checkbox>
								)}
							</Space>
						</Form.Item>

						{formType.toLowerCase() === 'interested' && (
							<Form.Item>
								<Checkbox
									checked={currentMetadata.showUserEmail}
									onChange={(e) =>
										updateMetadata(
											'showUserEmail',
											e.target.checked,
										)
									}
								>
									Show user's email address
								</Checkbox>
							</Form.Item>
						)}
						{formType.toLowerCase() === 'acceptance' && (
							<Form.Item>
								<Checkbox
									checked={currentMetadata.askForPhoneNumber}
									onChange={(e) =>
										updateMetadata(
											'askForPhoneNumber',
											e.target.checked,
										)
									}
								>
									Ask for Candidate Phone Number
								</Checkbox>
							</Form.Item>
						)}
					</>
				)}
				
				{formType.toLowerCase() === 'custom' && (
					<Form.Item
						label="Form Connection ID"
						help={isSuperAdmin
							? "A unique identifier used to connect this form to the application"
							: "A unique identifier used to connect this form to the application (Only editable by super admins)"}
					>
						{isSuperAdmin ? (
							<Input
								placeholder="Enter a unique identifier for this form"
								value={currentMetadata.formConnectionId || ''}
								onChange={(e) =>
									updateMetadata('formConnectionId', e.target.value)
								}
							/>
						) : (
							<Input
								placeholder="Enter a unique identifier for this form"
								value={currentMetadata.formConnectionId || ''}
								disabled
								style={{ color: 'rgba(0, 0, 0, 0.65)' }}
							/>
						)}
					</Form.Item>
				)}
			</Form>
		</Card>
	);
});

export default FormMetadataSettings;
